import styled from 'styled-components';
import { Form } from '@unform/web';

export const Filter = styled(Form)`
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  display: flex;
  align-items: center;
  justify-content: space-between;

  .generate_schedule_task,
  .description {
    width: 33%;
  }

  .type {
    width: 20%;
  }

  > div + div {
    margin-left: 16px;
  }

  button {
    border: 0;
    background: transparent;
    margin: 0 16px;
    transition: opacity 0.2s;
    width: 4%;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    svg {
      color: ${({ theme }) => theme.colors.primary};
      height: 20px;
      width: 20px;
    }
  }
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;

  .table {
    .generate_schedule_task {
      width: 12%;
    }
  }

  .deadline_days {
    padding-left: 8px;
    width: 8%;
  }

  .weight {
    width: 5%;
  }

  .type {
    width: 10%;
  }

  .description {
    width: 25%;
  }

  .evaluator {
    width: 10%;
  }
`;

export const KpiRegistrationInfo = styled.div`
  display: flex;
  flex-direction: column;

  .deadline_days,
  .type,
  .weight {
    width: 10%;
  }

  .description {
    width: 35%;
  }

  .evaluator {
    width: 30%;
  }

  .checkbox {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    > input {
      margin-right: 16px;
      transform: scale(1.5);
    }
  }
`;
